import { validateForm, renderRecaptcha } from './../../helpers/validator';
import { FORMS } from './../../helpers/constants';

let claimPageForm;
let formValues = {};
let claimFormSwiper;

const UNPROFESSIONAL_EMAIL_DOMAINS = ['gmail', 'hotmail', 'qq', 'yahoo', 'outlook', 'naver', '126', 'live']
const regexExcludedEmails = UNPROFESSIONAL_EMAIL_DOMAINS.reduce((acc, domain) => `${acc}(?!${domain})`, '')

const claimPageFormRules = {
  job_email: ['required', `regex:/[\\w-\\.]+@${regexExcludedEmails}([\\w-]+\\.)+[\\w-]{2,8}/`],
  name: 'required|string|min:3',
  job_title: 'required',
  country: 'required'
}

function initClaimTooltips () {
  const tooltipTriggers = document.querySelectorAll('[data-toggle="tooltip"]');
  if (!tooltipTriggers.length) return;
  const tooltipTemplate = document.getElementById('js-claim-page-tooltip-template');

  Array.from(tooltipTriggers).forEach(el => {
    const { claimType } = el.dataset;
    const tooltipText = claimType ? window.NFT.I18n.claim_page[claimType] : window.NFT.I18n.default_claim_page;
    const template = tooltipTemplate.content.cloneNode(true);
    template.querySelector('.js-claim-page-content').textContent = tooltipText;
    const tooltip = new window.AFD.Tooltip(el, template);
    el.addEventListener('mouseenter', e => {
      tooltip.open(e);
      return false;
    });
    window.$(document).on(':company-sidebar-fixed', () => {
      if (!tooltip.isActive()) return;
      tooltip.updatePosition(el);
    });
  });
}

function initClaimModal () {
  const claimBtns = Array.from(document.querySelectorAll('.js-claim-page-cta'));
  claimBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      document.getElementById('claim-page-form').scrollIntoView()
      window.AFD.modals.open('#claim-page-modal')
    });
  });
  claimFormSwiper = new window.Swiper('#claim-page-modal .swiper-container', {
    preventClicks: false,
    preventInteractionOnTransition: true,
    allowTouchMove: false
  });

  claimFormSwiper.on('slideChange', function () {
    if (window.getDevice() === 'desktop' && claimFormSwiper.activeIndex === 1) {
      document.querySelector('#claim-page-modal .swiper-container').style.width = '360px';
    }
  });
}

function updateErrorMessagesInDOM (formElements, errors) {
  Object.entries(formElements)
    .forEach(([key, element]) => {
      const parent = element.parentElement;
      if (errors[key]) {
        parent.querySelector('.js-error-hint').innerText = errors[key];
        parent.classList.add('has-error');
      } else {
        parent.classList.remove('has-error');
      }
    });
}

function validateClaimForm (e) {
  e.preventDefault();
  const formElements = {
    job_email: this.querySelector('[name="job_email"]'),
    name: this.querySelector('[name="name"]'),
    job_title: this.querySelector('[name="job_title"]'),
    country: this.querySelector('[name="country"]'),
    phone: this.querySelector('[name="phone"]')
  };

  formValues = Object.entries(formElements).reduce((acc, [key, field]) => {
    acc[key] = field.value
    return acc
  }, {})
  const validation = validateForm(formValues, [], claimPageFormRules);
  updateErrorMessagesInDOM(formElements, validation.errors.errors);

  if (validation.errorCount) return;
  window.grecaptcha.execute(window.NFT.recaptchaIds[FORMS.CLAIM_PAGE]);
}

async function claimPageSubmit (token) {
  const CLAIM_URL = claimPageForm.dataset['claimUrl'];
  if (!Object.keys(formValues).length || !CLAIM_URL) return;
  claimFormSwiper.slideNext();

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  /* eslint-disable-next-line camelcase */
  const requestBody = { claim_request: { ...formValues } };

  const options = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(requestBody)
  };

  const response = await fetch(CLAIM_URL, options);
  if (response.ok) {
    document.querySelector('.js-modal-loading-logo').classList.add('afd-hide');
    document.querySelector('.thanks__content').classList.remove('afd-hide');

    const btnGotIt = document.querySelector('.js-modal-close');
    btnGotIt.addEventListener('click', () => { window.AFD.modals.closeNow('#claim-page-modal') });
  }
}

export function initCompanyFeatures () {
  initClaimTooltips();
  initClaimModal();

  claimPageForm = document.getElementById('claim-page-form');
  if (claimPageForm) {
    renderRecaptcha(document.getElementById('claim-page-recaptcha'), claimPageSubmit, FORMS.CLAIM_PAGE);
    claimPageForm.addEventListener('submit', validateClaimForm);
  }
}